<template>
  <div class="marketing TopHeadder">
      <!-- 智能营销 -->
      <div class="bannerBox">
          <img src="../../assets/image/data_banner.png" />
           <div class="bannerTitle">
              <h3>数字化运营</h3>
              <p>数据驱动的管理和运营，赋能企业以</p>
              <span>更敏锐的市场洞察</span>
              <span>更灵活的个性化服务能力</span>
              <span>更快的产品迭代速度及更低的成本</span>
             <p>实现数据从成本中心到利润中心的转化，构建全面的数字化运营能力</p>
          </div>
      </div>
      <div class="data_item1 PublicPadding">
         <h4 class="title">数据驱动能力构建</h4>
         <h5 class="titleh5">帮助企业提升运营模式和IT构架，即时洞察经营过程，快速反应市场变化，实现精准营销，快速推出适应市场需求的产品</h5>
         <ul>
            <li class="datali1">
                <i><img src="../../assets/image/data1_1.png" /></i>
                <h3>数字化</h3>
                <p>数据驱动的产品迭代、运营优化、市场营销和商业决策</p>
            </li>
            <li class="datali2">
                <i><img src="../../assets/image/data1_2.png" /></i>
                <h3>智能化</h3>
                <p>基于人工智能和机器学习的个性化产品</p>
            </li>
            <li class="datali3">
                <i><img src="../../assets/image/data1_3.png" /></i>
                <h3>标准化</h3>
                <p>通过数据能力及智能，化解复杂环境的不确定性，优化资源配置效率</p>
            </li>
            <li class="datali4">
                <i><img src="../../assets/image/data1_4.png" /></i>
                <h3>精细化</h3>
                <p>基于深度数据洞察提供个性化服务，实现精准营销、降本增效</p>
            </li>

         </ul>
      </div>


      <div class="market_item3 PublicPadding colorbg">
          <h4 class="title">功能亮点</h4>
          <ul>
             <li class="m3_li1" :class="{active:activeChild==1}" v-on:click="activeTab(1)">
               <div>
                  <i></i>
                  <h3>云原生技术架构</h3>
               </div>
             </li>
             <li class="m3_li2" :class="{active:activeChild==2}" v-on:click="activeTab(2)">
                <div>
                  <i></i>
                  <h3> 数据驱动的生态闭环</h3>
                </div>
             </li>
             <li class="m3_li3" :class="{active:activeChild==3}" v-on:click="activeTab(3)">
                <div>
                  <i></i>
                  <h3>数据和应用资产的全局管理与洞察</h3>
                </div>
             </li>
             <li class="m3_li4" :class="{active:activeChild==4}" v-on:click="activeTab(4)">
               <div>
                  <i></i>
                  <h3>数据和服务的中台方法论</h3>
                </div>
             </li>
             
          </ul>
          <ol>
             <li v-show="activeChild==1">
                <div>
                   <h3>云原生技术架构</h3>
                   <p>将大数据/AI技术组件和业务应用以统一的容器化方式混合运行在高效可靠的云原生技术架构上，支持弹性扩展和资源共享</p>      
                </div>
                <i>
                  <img src="../../assets/image/d4_1.png"/>
                </i>
             </li>
              <li v-show="activeChild==2">
                <div>
                   <h3>数据驱动的生态闭环</h3>
                   <p>一站式帮助企业完成从基础设施的资源管理、数据驱动的IT架构，到自助式数据能力赋能的完整闭环，渐进式完成数字化运营体系的建设和升级</p> 
                </div>
                <i>
                  <img src="../../assets/image/d4_2.jpg"/>
                </i>
             </li>
             <li v-show="activeChild==3">
                <div>
                   <h3>数据和应用资产的全局管理与洞察</h3>
                   <p>将数据、应用、资源和用户进行统一管理，横跨系统所有组件，多角度、多视图查看组织和系统，达到零死角洞察</p> 
                </div>
                <i>
                  <img src="../../assets/image/d4_3.jpg"/>
                </i>
             </li>
              <li v-show="activeChild==4">
               <div>
                   <h3>数据和服务的中台方法论</h3>
                   <p>由业务进行驱动，端到端、按需迭代式部署数据集成、数据服务和模型服务等中台服务，在云原生架构实现数据能力的抽象、共享和复用</p>  
                </div>
                <i>
                  <img src="../../assets/image/d4_4.jpg"/>
                </i>
             </li>
           
          </ol>
      </div>
      <div class="market_item4 PublicPadding">
        <h4 class="title">更多功能支撑，让外呼更有温度</h4>
        <ul>
           <li>
              <i><img src="../../assets/image/dsj1.png"/></i>
              <h3>数据治理</h3>
              <p>数据的语法及语义的规范化，数据正确性，完整性</p>
           </li>
           <li class="d4_li1">
              <i><img src="../../assets/image/dsj2.png"/></i>
              <h3>数据流水线管理</h3>
              <p>创建云原生数据流水线，支持各种云原生数据接入与处理组件</p>
           </li>
            <li class="d4_li1">
              <i><img src="../../assets/image/dsj3.png"/></i>
              <h3>基础平台</h3>
              <p>云原生PaaS平台，容器化运行Hadoop/Hive/Spark/Kafka …大数据组件</p>
           </li>
            <li>
              <i><img src="../../assets/image/dsj4.png"/></i>
              <h3>算法平台/算力管理</h3>
              <p>有效地编写算法及运行算法、算力管理</p>
           </li>
            <li>
              <i><img src="../../assets/image/dsj5.png"/></i>
              <h3>数据中台服务体系</h3>
              <p>数据及服务、模型及服务、标签系统、数据可视化等</p>
           </li>
            <li>
              <i><img src="../../assets/image/dsj6.png"/></i>
              <h3>数据应用资产管理</h3>
              <p>数据与应用资产的全局管理</p>
           </li>
           <li>
              <i><img src="../../assets/image/dsj7.png"/></i>
              <h3>企业级运维</h3>
              <p>多用户，安全，监控，报警，审计</p>
           </li>
        </ul>
      </div>
      <div class="data_item2 PublicPadding">
          <i><img src="../../assets/image/d2_1.png"/></i>
      </div>
      <div class="data_item3 PublicPadding">
          <h4 class="title">企业可以在未来实现</h4>
           <ul>
                <li class="data5_li1"><p>快速的智能的商业决策支持</p></li>
                <li class="data5_li2"><p>产品线的快速迭代</p></li>
                <li class="data5_li3"><p>完善的 ROI 管理</p></li>
                <li class="data5_li4"><p>精细化运营和管理</p></li>
                <li class="data5_li5"><p>内部数据能力的共享和复用</p></li>
           </ul>
      </div>
      <div class="data_item4 PublicPadding colorbg">
          <h4 class="title">企业可以在未来实现</h4>
           <div class="datadiv">
                <img class="dataimg" src="../../assets/image/data6_t.png"/>
                <ul class="clear">
                    <li class="data6_li1">
                        <i><img src="../../assets/image/d4_12.png" /></i>
                        <div>
                            <h3>一揽子产品服务</h3>
                            <p>整套BDOS产品系列解决方案，为合作伙伴提供数字化运营/数据中台系统从规划到上线的整套流程服务</p>
                        </div>
                    </li>
                    <li class="data6_li2">
                        <i><img src="../../assets/image/d4_2.png" /></i>
                        <div>
                            <h3>单产品+定制开发服务</h3>
                            <p>为客户提供BDOS单组件产品，并可以按需求场景进行定制开发服务</p>
                        </div>
                    </li>
                    <li class="data6_li3">
                        <i><img src="../../assets/image/d4_3.png" /></i>
                        <div>
                            <h3>产品与技术赋能</h3>
                            <p>借助BDOS产品组合赋能合作伙 伴，共同开发行业大数据/数据中台解决方案</p>
                        </div>
                    </li>
                    <li class="data6_li4">
                        <i><img src="../../assets/image/d4_4.png" /></i>
                        <div>
                            <h3>OEM</h3>
                            <p>可根据合作伙伴需求，支持产品封装服务（OEM）</p>
                        </div>
                    </li>
                </ul>
            </div>
      </div>
      <Popup v-show="$store.state.isshow"></Popup>
  </div> 
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'marketing',
  data () {
    return {
      activeChild:1,
      
    }
  },
  components:{
        Popup
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
   
    activeTab(num) {
       this.activeChild=num
    },
  }
}
</script>


<style scoped>
.audioBox{display: none;}
.bannerTitle{
  top:1rem;
}
.bannerTitle h3{
  text-align: left;
}
.bannerTitle span{
  font-size: 0.16rem;
  color: #fff;
  opacity: 0.7;
  display: block;
  margin-bottom: 0.1rem;
}
.bannerTitle p{
  text-align: left;
}
.data_item1 .titleh5{
    width: 6.1rem;
    margin: 0 auto;
    color: #999999;
    margin-top:0.3rem;
}
.data_item1 ul{
    overflow: hidden;
    box-shadow: 0 0 0.08rem #ccc;
    width: 7rem;
    margin:0 auto;
    margin-top:0.5rem;
}
.data_item1 ul li{
    width: 3.49rem;
    height: 2.6rem;
    float: left;
}
.data_item1 ul li i{
    float: left;
    width: 0.65rem;
    height: 0.65rem;
    margin: 0.5rem 0.15rem 0 0.3rem;
    margin-right: 0.15rem;
}
.data_item1 ul li i img{
    display: block;
    width: 0.65rem;
    height: 0.65rem;   
}
.data_item1 ul li h3{
    float: left;
     width: 2rem;
    font-size: 0.24rem;
    font-weight: 400;
    color: #333333;
    margin-top:0.5rem;
    margin-bottom:0.2rem ;
}
.data_item1 ul li p{
    float: left;
    width: 2.2rem;
    font-size: 0.2rem;
    color: #999999;
    line-height: 0.36rem;
}
.data_item1 ul li.datali1{
    border-right: 0.01rem solid #ccc;
    border-bottom: 0.01rem solid #ccc;
}
.data_item1 ul li.datali2{
     width: 3.49rem;
     height: 2.61rem;
     border-bottom:0.01rem solid #ccc;
}
.data_item1 ul li.datali3{
     width: 3.49rem;
     height: 2.61rem;
}
.data_item1 ul li.datali4{
     border-left: 0.01rem solid #ccc;
}
.market_item3 ul{
  /* overflow: hidden; */
  height: 1.7rem;
  background: #eefefc;
  border-top:0.02rem solid #90e4f7;
  border-bottom:0.02rem solid #90e4f7;
  margin-top:0.4rem;
}

.market_item3 ul li{
  float: left;
  width: 1.87rem;
}
.market_item3 ul li div{
  height: 1.51rem;
  border-left: 0.01rem solid #90e4f7;
  padding-top: 0.2rem;
}
.market_item3 ul li.active{
  padding-bottom:0.2rem ;
}
.market_item3 ul li:first-child div{
  border-left: none;
}
.market_item3 ul li i{
  display: block;
  width: 0.3rem;
  height: 0.3rem;
  margin: 0 auto; 
  margin-bottom: 0.17rem;
}
.market_item3 ul li.m3_li1 i{
   background: url("../../assets/image/data2_1.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2 i{
   background: url("../../assets/image/data2_2.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3 i{
   background: url("../../assets/image/data2_3.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4 i{
   background: url("../../assets/image/data2_4.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li1.active i{
   background: url("../../assets/image/data2_11.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2.active i{
   background: url("../../assets/image/data2_22.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3.active i{
   background: url("../../assets/image/data2_33.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4.active i{
   background: url("../../assets/image/data2_44.png") no-repeat center;
   background-size:100% 100%;
}

.market_item3 ul li h3{
  font-size: 0.18rem;
  font-weight: 400;
  color: #00C7FF;
  line-height: 0.3rem;
  width: 1.2rem;
  margin: 0 auto;
  padding-bottom:0.25rem ;
}
.market_item3 ul li.active{
  background:url("../../assets/image/m_li.png") no-repeat center;
  background-size:100% 100%;
}
.market_item3 ul li.active h3{
  color: #fff;
}
.market_item3 ol{
  width: 7rem;
  height: 4.56rem; 
  margin:0 auto;
  margin-top: 0.5rem;
  box-shadow: 0 0 0.08rem #ccc;
  background: #fff;
}
.market_item3 ol li{
  overflow: hidden;
}
.market_item3 ol li div{
  float: left;
}
.market_item3 ol li div h3{
    width: 2.7rem;
  font-size: 0.3rem;
  font-weight: 400;
  color: #33CAF2;
  line-height: 0.3rem;
  margin: 0.8rem 0 0.3rem 0.3rem;
}
.market_item3 ol li div p{  
  font-size: 0.18rem;
  font-weight: 400;
  color: #666666;
  margin-top:0.2rem;
  margin-left: 0.3rem;
  width: 2.9rem;
}
.market_item3 ol li i{
  float: right;
  display: block;
  width:3.42rem;
  height: 3.82rem;
  margin:0.35rem 0.26rem 0 0;
}
.market_item3 ol li i img{
  display: block;
  width:3.42rem;
  height: 3.82rem;
}
.market_item4 ul{
  width: 7rem;
  margin: 0 auto;
  margin-top:0.4rem;
}
.market_item4 ul li{
  overflow: hidden;
  background: #fff;
  margin-bottom: 0.3rem;
  height: 1.4rem;
  box-shadow: 0 0 0.08rem #ccc;
}
.market_item4 ul li i{
  float: left;
  width: 1.03rem;
  height: 0.97rem;
  margin:0.24rem 0 0 0.22rem;
}
.market_item4 ul li i img{
  display: block;
  width: 1.03rem;
  height: 0.97rem;
}
.market_item4 ul li h3{
    font-size: 0.24rem;
    font-weight: 400;
    color: #333333;
    padding-left: 1.5rem;
    margin-top:0.3rem;
}
.market_item4 ul li p{
  font-size: 0.22rem;
  font-weight: 400;
  color: #666666;
  margin-top:0.1rem;
  padding-left: 1.5rem;
  padding-right:0.2rem ;
}
.market_item4 ul li.d4_li1 h3{
  margin-top:0.2rem;
}
.data_item2{      
  background:url("../../assets/image/d2_bg.jpg") no-repeat center;
  background-size:100% 100%;
  height: 14.06rem;
  padding-top: 1.3rem;
}
.data_item2 i{
    display: block;
    width: 7.5rem;
    height: 13.46rem;
}
.data_item2 i img{
    display: block;
    width: 7.5rem;
    height: 13.46rem;
}
.data_item3 ul {
    background:url("../../assets/image/d3_1.png") no-repeat center;
    background-size:100% 100%;
    width:3.3rem;
    height:7.05rem;
    margin:0 auto;
    margin-top:0.6rem;
    margin-bottom:0.6rem;
    position:relative;
}
.data_item3 ul li p {
    font-size: 0.16rem;
    color: #333333;
    line-height:0.3rem;
    width: 1.5rem;
}
.data_item3 ul li.data5_li1 {
    position:absolute;
    top:0.1rem;
    left:-1.8rem;
}
.data_item3 ul li.data5_li1 p{
    text-align: right;
}
.data_item3 ul li.data5_li2 p{
    text-align: right;
}
.data_item3 ul li.data5_li3 p{
    text-align: right;
}
.data_item3 ul li.data5_li2 {
    position: absolute;
    top:3rem;
    left:-1.8rem;

}
.data_item3 ul li.data5_li3 {
    position: absolute;
    bottom:0.1rem;
    left:-1.8rem;
}
.data_item3 ul li.data5_li4 {
    position: absolute;
    top:1.7rem;
    right:-1.8rem;
}
.data_item3 ul li.data5_li5 {
    position: absolute;
    bottom: 1.8rem;
    right: -1.8rem;
}

.data_item4 ul{
    padding-left: 0.2rem;
    width: 110%;
}
.data_item4 ul li {
    float: left;
    width: 3.4rem;
    background: #fff;
    overflow: hidden;
    margin-right:0.3rem;
    margin-top:0.3rem;
    height:3rem;
}

.data_item4 ul li i {
    float: left;
      margin:0.48rem 0.16rem 0 0.6rem;
}
.data_item4 ul li.data6_li1 i{
    width:0.28rem;
    height:0.34rem;
}
.data_item4 ul li.data6_li1 i img{
    display: block;
    width:0.28rem;
    height:0.34rem;
}
.data_item4 ul li.data6_li2 i {
    width: 0.3rem;
    height: 0.3rem;
}
.data_item4 ul li.data6_li2 i img {
    display: block;
    width: 0.3rem;
    height: 0.3rem;
}
.data_item4 ul li.data6_li3 i {
    width: 0.37rem;
    height: 0.37rem;
}
.data_item4 ul li.data6_li3 i img{
    display: block;
    width: 0.37rem;
    height: 0.37rem;
}
.data_item4 ul li.data6_li4 i {
    width: 0.32rem;
    height:0.29rem;
}
.data_item4 ul li.data6_li4 i img {
    display: block;
    width: 0.32rem;
    height:0.29rem;
}
.data_item4 ul li div{
    float:left;
}
.data_item4 ul li div h3 {
    font-size: 0.2rem;
    font-weight: 400;
    color: #333333;
    line-height: 0.2rem;
    margin-top:0.5rem;
}
.data_item4 ul li div p {
    width: 2rem;
    font-size: 0.14rem;
    color: #999999;
    line-height:0.32rem;
    margin-top:0.1rem;
}
.data_item4 .datadiv {
    position: relative; 
    margin-top:0.2rem;
}
.data_item4 .dataimg{
    position:absolute;
    top:2.3rem;
    left:2.8rem;
    display: block;
    width: 1.96rem;
    height: 1.96rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product/bigData.vue